import { initTianRunService } from '../lib/service';
export var postStoreInitialized = function () {
    initTianRunService();
};
